import { useState, useEffect, useRef } from "react";
import {
  UpdateLead,
  fetchAllLeads,
  fetchLeadStatus,
} from "../../actions/admin/leads";
import { Link } from "react-router-dom";
import StatusSelector from "../../components/admin/StatusSelector";
import DoughnutChart from "../../components/admin/DoughnutChart";
import FilterIcon from "../../utils/assets/client/filter.svg";
import DownArrow from "../../utils/assets/client/down-white.svg";
import "./leads.css";
import infoSVG from "../../utils/assets/information.svg";
const ManageLeads = () => {
  const [LeadsData, setLeadsData] = useState([]);
  const [leadsValue, setLeadsValue] = useState([]);
  const [filterOpen, setIsFilterOpen] = useState(false);
  const [leadStatusData, setLeadStatusData] = useState([]);
  const [filters, setFilters] = useState({
    nameOrID: "",
    email: "",
    phone: "",
    assignedTo: "",
    status: "",
  });

  const [referenceData, setReferenceData] = useState([]);
  const [donutStatus, setDonutStatus] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [filteredData, setFilteredData] = useState([]);

  function calculateLeadValues(data) {
    return data.map((item) => {
      const total = item.lead_items.reduce(
        (sum, lead) => sum + lead?.lead_value,
        0
      );
      return total;
    });
  }
  const leadStatus = [
    {
      id: 1,
      name: "New",
      slug: "new",
      colorCode: "#3698fa",
    },
    {
      id: 2,
      name: "In Progress",
      slug: "inprogress",
      colorCode: "#f3d216",
    },
    {
      id: 3,
      name: "Won",
      slug: "won",
      colorCode: "#2bdb0f",
    },
    {
      id: 4,
      name: "Cancelled",
      slug: "cancelled",
      colorCode: "#fc3600",
    },
    {
      id: 5,
      name: "Lost",
      slug: "lost",
      colorCode: "#924834",
    },
    {
      id: 6,
      name: "Expired",
      slug: "expired",
      colorCode: "#7547f0",
    },
    {
      id: 7,
      name: "Waiting",
      slug: "waiting",
      colorCode: "#47d6f0",
    },
  ];

  const getStatusDetailsObjectFromSlug = (name) => {
    console.log(name, "name");
    console.log(leadStatusData, "leadStatusData");
    const response =
      (leadStatusData &&
        leadStatusData.find(
          (item) => item.title.toLowerCase() == name.toLowerCase()
        )) ||
      [];
    console.log("response", response);
    return response;
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetchAllLeads(token).then((res) => {
      setLeadsData(res.data);
      setFilteredData(res.data);
      const computedDataSetValueRef = labelDataRef.map(
        (label) => res.data.filter((data) => data.reference === label).length
      );
      setReferenceData(computedDataSetValueRef);
      const computedDataSetStatusRef = labelData.map(
        (label) =>
          res.data.filter((data) => data.lead_items[0]?.status === label).length
      );
      setDonutStatus(computedDataSetStatusRef);
    });

    const result = calculateLeadValues(LeadsData);

    fetchLeadStatus(token).then((res) => {
      setLeadStatusData(res.data);
    });

    setLeadsValue(result);
  }, []);

  const labelData = [
    "New",
    "In Progress",
    "Won",
    "Cancelled",
    "Lost",
    "Expired",
    "Waiting",
  ];

  // const dataSetValue = [10, 15, 12, 11, 23, 20, 1];

  const labelDataRef = [
    "Facebook",
    "Bing",
    "Search Engine",
    "referral",
    "Google Ads",
  ];

  // const dataVal =

  // setReferenceData(labelDataRef.map(
  //   (label) => LeadsData.filter((data) => data.reference === label).length
  // ))
  // console.log("bshuabjcjdwciewj", dataVal);

  // const dataSetValueRef = [1,0,0,2,0];

  // const dataSetValueRef =

  const drawerRef = useRef(null);

  const toggleFilter = () => {
    setIsFilterOpen((prev) => !prev);

    // Dynamically adjust the height when opening
    if (!filterOpen) {
      const scrollHeight = drawerRef.current.scrollHeight;
      drawerRef.current.style.maxHeight = `${scrollHeight}px`;
    } else {
      // Collapse the height when closing
      drawerRef.current.style.maxHeight = "0px";
    }
  };

  // Handle filter changes
  //  const handleFilterChange = () => {

  //   // Update filtered data
  //   setFilteredData(
  //     LeadsData.filter((item) => {
  //       return (
  //         (item.customer.first_name.toLowerCase().includes(filters.nameOrID.toLowerCase())) &&
  //         ( item.customer.last_name.toLowerCase().includes(filters.nameOrID.toLowerCase())) &&
  //         (item.customer.lead_id.toLowerCase().includes(filters.nameOrID.toLowerCase())) &&
  //         ( item.customer.email.toLowerCase().includes(filters.email.toLowerCase()))
  //       );
  //     })
  //   );
  // };

  const handleFilterChange = (values) => {
    // Update filters state

    // Filter data
    const filtered = LeadsData.filter((item) => {
      const nameOrIDMatch =
        !values.nameOrID ||
        item.customer.first_name
          .toLowerCase()
          .includes(values.nameOrID.toLowerCase()) ||
        item.customer.last_name
          .toLowerCase()
          .includes(values.nameOrID.toLowerCase()) ||
        item.lead_id.toLowerCase().includes(values.nameOrID.toLowerCase());

      const emailMatch =
        !values.email ||
        item.customer.email.toLowerCase().includes(values.email.toLowerCase());

      const phoneMatch =
        !values.phone ||
        item.customer.phone.toLowerCase().includes(values.phone.toLowerCase());

      const assignedToMatch =
        !values.assignedTo ||
        item.assigned_to
          .toLowerCase()
          .includes(values.assignedTo.toLowerCase());

      return nameOrIDMatch && emailMatch && phoneMatch && assignedToMatch;
    });
    setIsLoading(true);
    setTimeout(() => {
      setFilteredData(filtered);
      setIsLoading(false);
    }, 1000);
  };

  const clearFilters = () => {
    setIsLoading(true);

    setFilters({
      nameOrID: "",
      email: "",
      phone: "",
      assignedTo: "",
      status: "",
    });
    const fill = {
      nameOrID: "",
      email: "",
      phone: "",
      assignedTo: "",
      status: "",
    };
    setTimeout(() => {
      handleFilterChange(fill);
      setIsLoading(false);
    }, 1000);
  };

  const handleStatusChange = (data, item) => {
    const token = localStorage.getItem("token");

    const DataSet = {
      ...item,
    };
    DataSet["lead_items"].forEach((leads) => {
      leads.status = data.id;
      delete leads.created_at;
      delete leads.updated_at;
      delete leads.brand.created_at;
      delete leads.brand.updated_at;
      delete leads.category.created_at;
      delete leads.category.updated_at;
      leads.defects.forEach((defect) => {
        delete defect.created_at;
        delete defect.updated_at;
      });
      leads.devices.forEach((devices) => {
        delete devices.created_at;
        delete devices.updated_at;
      });
    });
    delete DataSet.created_at;
    delete DataSet.customer.created_at;
    delete DataSet.user.created_at;
    delete DataSet.updated_at;
    delete DataSet.customer.updated_at;
    delete DataSet.user.updated_at;

    console.log("DataSet", DataSet);
    UpdateLead(token, DataSet).then((res) => {
      console.log("api...", res);
    });
  };

  return (
    <div className="bg-light"  >
      {/* header start */}
      <div className="d-flex row p-3 pb-0">
        <div className="d-flex justify-content-between align-items-center ">
          <button
            onClick={toggleFilter}
            className="btn bg-black  text-white p-2 px-3 border-0 d-flex justify-content-center align-items-center"
          >
            {" "}
            <img width={20} src={FilterIcon} alt="filter" />{" "}
            <span className="mx-2">Search Filter</span>{" "}
            <img width={25} height={25} src={DownArrow} alt="filter" />{" "}
          </button>
          <Link to="/admin/createLead" className="btn bg-black  text-white p-2 px-3 border-0">
            + New Lead
          </Link>
        </div>
      </div>
      <div
        className={`filter-drawer row card  mx-3 mb-3 mt-3  border_bg_color ${
          filterOpen ? "open" : "mb-0 mx-0"
        }`}
        ref={drawerRef}
        style={{ opacity: filterOpen ? 1 : 0 }}
      >
        <div className="row d-flex justify-content-start align-items-center p-3">
          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-2">
            <label className="form-label ">Search by</label>
            <input
              type="text"
              className="form-control bg-light"
              placeholder="Name / ID"
              name="nameOrID"
              value={filters.nameOrID}

              onChange={(e) =>
                setFilters({ ...filters, nameOrID: e.target.value })
              }
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-2">
            <label className="form-label">Email </label>
            <input
              type="text"
              className="form-control bg-light"
              name="email"
              value={filters.email}
              onChange={(e) =>
                setFilters({ ...filters, email: e.target.value })
              }
              placeholder="Email"
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-2">
            <label className="form-label">Phone Number </label>
            <input
              type="text"
              className="form-control bg-light"
              name="email"
              value={filters.phone}
              onChange={(e) =>
                setFilters({ ...filters, phone: e.target.value })
              }
              placeholder="Email"
            />
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-2">
            <label className="form-label">Assigned to</label>
            <input
              type="text"
              name="assignedTo"
              value={filters.assignedTo}
              onChange={(e) =>
                setFilters({ ...filters, assignedTo: e.target.value })
              }
              className="form-control bg-light"
              placeholder="Assinged To"
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-2">
            <label className="form-label">Status </label>
            <input
              type="text"
              name="status"
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
              className="form-control bg-light"
              placeholder="Status"
            />
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 my-2">
            <button
              onClick={() => clearFilters()}
              className="btn btn-sm bg-black text-white p-2 px-3 "
            >
              <img width={20} src={FilterIcon} alt="filter" />{" "}
              <span>Clear Filter</span>
            </button>
            <button
              onClick={() => handleFilterChange(filters)}
              className="btn btn-sm bg-black text-white p-2 px-3 mx-2 px-2"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {/* header end */}

      {/* Doughnut start */}
      <div className="row px-3">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
          <div className="card border_bg_color card_radius d-flex justify-content-center align-items-center">
            <DoughnutChart
              labelData={labelData}
              dataSetValue={donutStatus}
              chartName={"Total Leads by Status"}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div className="card border_bg_color card_radius d-flex justify-content-center align-items-center">
            <DoughnutChart
              labelData={labelDataRef}
              dataSetValue={referenceData}
              chartName={"Total Leads by Refferals"}
            />
          </div>
        </div>
      </div>
      {/* Doughnut end */}

      {/* form start */}

      <div className="my-3 mx-4">
        <div className="row border_bg_col overflow-hidden">
          <p className="txt-head bg-black px-3 text-white  mb-0 p-2">Manage Lead (s)</p>
          {filteredData.length > 0 && filteredData ? (
            <table className="table   table-hover mb-0">
              <thead>
                <tr className="p-2">
                  <td className="px-3">Id</td>
                  <td>Task</td>
                  <td>Customer</td>
                  <td>Created Date</td>
                  <td>Created By</td>
                  <td>Due Date</td>
                  <td>Take Notes</td>
                  <td>Lead Value</td>
                  <td>Status</td>
                  <td>Assigned To</td>
                  <td>Refferal</td>
                  <td className="mx-0 px-0">more</td>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item) => {
                    return (
                      <tr className="p-3" key={item.id}>
                        <td className="px-3">
                          <Link
                            className="link_text"
                            to={`/admin/leads/${item.id}`}
                          >
                            {item.lead_id}
                          </Link>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            {item?.lead_items?.map((device) => {
                              return (
                                <>
                                  <span style={{ fontWeight: "400" }}>
                                    {device.brand.name}{" "}
                                    {device?.devices[0]?.title} -
                                  </span>
                                  {/* {
                                  device?.defects?.map((defect) => {
                                    return (
                                      <span>{defect.title}</span>
                                    )
                                  })
                                } */}
                                  <span>{device?.defects[0]?.title}</span>
                                  <span>{device?.defects[1]?.title}</span>
                                </>
                              );
                            })}
                          </div>
                        </td>
                        <td className="d-flex flex-column">
                          <div style={{maxWidth: "150px"}} className="d-flex flex-column">
                          <span className="text-truncate">
                            <Link className="link_text">
                              {item.user.first_name} {item.user.last_name}
                            </Link>
                          </span>
                          <span className="text-truncate">Mobile: {item.customer.phone}</span>
                          <span className="text-truncate">Email: {item.customer.email}</span>
                          <span className="text-truncate">Address: {item.customer.address}</span>
                          </div> 
                        </td>
                        <td>
                          {item.created_at
                            ? new Date(item.created_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "-"}
                        </td>
                        <td>Web</td>
                        <td>-</td>
                        <td>Take Notes</td>
                        <td>£ {item.lead_items[0]?.lead_value}</td>
                        <td>
                          <div className="" style={{maxWidth: "150px"}}>
                          {item?.lead_items &&
                          item?.lead_items[0] &&
                          getStatusDetailsObjectFromSlug(
                            item.lead_items[0]?.status
                          ) ? (
                            <StatusSelector
                              value={getStatusDetailsObjectFromSlug(
                                item?.lead_items[0]?.status
                              )}
                              Data={leadStatusData}
                              handleChange={handleStatusChange}
                              item={item}
                            />
                          ) : (
                            ""
                          )}
                          </div>
                          
                        </td>
                        <td>
                          {" "}
                          {item.assigned_to
                            ? item.assigned_to.first_name +
                              " " +
                              item.assigned_to.last_name
                            : "Not Yet Assigned"}{" "}
                        </td>
                        <td>{item.reference}</td>
                        <td>
                          {/* <div className="dropdown">
                            <button
                              className="btn btn-sm btn-secondary dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Action
                            </button>
                            <ul className="dropdown-menu">
                              <li>
                                <a className="dropdown-item" href="#">
                                  Edit
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="#">
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </div> */}
                          <div className="mx-2">
                            <Link>
                              <img width={15} src={infoSVG} alt="information" />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colspan="11"
                      className="table-active text-center txt-p py-2"
                      style={{ fontWeight: "500" }}
                    >
                      No Records
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <>
              <table className="table table-hover mb-0">
                <thead>
                  <tr className="p-2">
                    <td>Id</td>
                    <td>Task</td>
                    <td>Customer</td>
                    <td>Created Date</td>
                    <td>Created By</td>
                    <td>Due Date</td>
                    <td>Take Notes</td>
                    <td>Lead Value</td>
                    <td>Status</td>
                    <td>Assigned To</td>
                    <td>Refferal</td>
                  </tr>
                </thead>
              </table>
              <div className="d-flex justify-content-center align-items-center text-center mt-3">
                <p>No Records Found.</p>
              </div>
            </>
          )}

          {/* <div className="card_radius total_card bg_color_gray d-flex flex-column justify-content-center text-end p-3 f-16 txt-secondary">
            <div className="d-flex justify-content-between align-items-center">
              <span>Sub Total :</span>
              <span>$0.00</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span>Discount :</span>
              <span>$0.00</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span>GST :</span>
              <span>$0.00</span>
            </div>
            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-dark" style={{ fontSize: "20px" }}>
                Total :{" "}
              </span>
              <span className="text-dark" style={{ fontSize: "20px" }}>
                $0.00
              </span>
            </div>
          </div> */}
        </div>
      </div>

      {/* form ends */}
    </div>
  );
};

export default ManageLeads;
